import EVHeroCharging from './ev-hero-charging';
import EVHeroVehicle from './ev-hero-vehicle';

export interface EVHeroesProps {
  cdnUrl: string;
}

export default function EVHeroes({ cdnUrl }: EVHeroesProps) {
  const prefix = `${cdnUrl}/web/images`;

  return (
    <>
      <EVHeroVehicle prefix={prefix} />
      <EVHeroCharging prefix={prefix} />
    </>
  );
}
